{
  "name": "das-frontend",
  "private": true,
  "version": "1.0.0+d1915d3",
  "engines": {
    "node": "24"
  },
  "scripts": {
    "authenticate:all": "npm run authenticate:google && npm run authenticate:firebase && npm run artifact-registry-login",
    "authenticate:firebase": "firebase login --reauth",
    "authenticate:google": "gcloud auth login",
    "artifact-registry-login": "npx google-artifactregistry-auth --repo-config .npmrc --credential-config .npmrc",
    "build:development": "ng build --configuration development",
    "build:local": "ng build --configuration local",
    "build:staging": "ng build --configuration staging",
    "build:production": "ng build --configuration production",
    "build:test1": "ng build --configuration test1",
    "build:test2": "ng build --configuration test2",
    "build:test3": "ng build --configuration test3",
    "deploy:development": "npm run build:development && firebase deploy --only hosting --project development",
    "deploy:staging": "npm run build:staging && firebase deploy --only hosting --project staging",
    "deploy:test1": "npm run build:test1 && firebase deploy --only hosting --project test1",
    "deploy:test2": "npm run build:test2 && firebase deploy --only hosting --project test2",
    "deploy:test3": "npm run build:test3 && firebase deploy --only hosting --project test3",
    "extract-translations": "ng extract-i18n --format=json --out-file en.json --output-path public/i18n",
    "install:all": "npm install --ignore-scripts --legacy-peer-deps",
    "install:utils": "npm install @pactasign/utils@dev --ignore-scripts --legacy-peer-deps",
    "lint": "ng lint",
    "release": "semantic-release",
    "start": "ng serve",
    "start:local": "ng serve --configuration local",
    "test": "ng test"
  },
  "dependencies": {
    "@angular/cdk": "^22.0.0",
    "@angular/common": "^22.0.0",
    "@angular/compiler": "^22.0.0",
    "@angular/core": "^22.0.0",
    "@angular/forms": "^22.0.0",
    "@angular/platform-browser": "^22.0.0",
    "@angular/router": "^22.0.0",
    "@ngrx/operators": "^21.1.0",
    "@ngrx/signals": "^21.1.0",
    "@pactasign/utils": "^0.0.19",
    "firebase": "^12.8.0",
    "pdfjs-dist": "^5.4.394",
    "rxjs": "~7.8.0",
    "signature_pad": "^5.1.2",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^22.0.0",
    "@angular/cli": "^22.0.0",
    "@angular/compiler-cli": "^22.0.0",
    "@angular/localize": "^22.0.0",
    "@eslint/js": "^9.39.2",
    "@semantic-release/commit-analyzer": "^13.0.0",
    "@semantic-release/git": "^10.0.0",
    "@semantic-release/npm": "^12.0.0",
    "@semantic-release/release-notes-generator": "^14.0.0",
    "@types/jasmine": "~5.1.0",
    "angular-eslint": "22.0.0",
    "eslint": "^9.39.2",
    "firebase-tools": "^15.17.0",
    "globals": "^17.3.0",
    "jasmine-core": "~5.9.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "semantic-release": "^24.0.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.60.1"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  }
}
